import React from 'react';
import BaseMixin from '../common/base-mixin.js';
import ElementaryMixin from '../common/elementary-mixin.js';
import Tools from '../common/tools.js';
import Button from '../bricks/button.js';
import Glyphicon from '../bricks/glyphicon.js';
import Column from '../bricks/column.js';
import Span from '../bricks/span.js';

import './page-column.less';

export const PageColumn = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Page.Column',
    classNames: {
      main: 'uu5-bricks-page-column',
      float: 'uu5-bricks-page-column-float',
      buttonWrapper: 'uu5-bricks-page-column-button-wrapper',
      buttonOpen: 'uu5-bricks-page-column-button-open',
      buttonClose: 'uu5-bricks-page-column-button-close',
      open: 'uu5-bricks-page-column-open'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    width: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    minWidth: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    maxWidth: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    right: React.PropTypes.bool,
    button: React.PropTypes.bool,
    open: React.PropTypes.bool,
    block: React.PropTypes.bool,
    openContent: React.PropTypes.any,
    closedContent: React.PropTypes.any
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      width: null,
      minWidth: null,
      maxWidth: null,
      right: false,
      button: false,
      open: false,
      block: false,
      openContent: null,
      closedContent: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState() {
    return {
      open: this.props.block || this.props.open
    };
  },

  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldRender(nextProps, nextState);
  },

  componentWillReceiveProps(nextProps){
    if (nextProps.controlled) {
      this.setState({ open: nextProps.block || nextProps.open });
    }
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  isFloat() {
    return this.props.minWidth || this.props.maxWidth;
  },

  open(setStateCallback){
    !this.props.block && this.setState({ open: true }, setStateCallback);
    return this;
  },

  close(setStateCallback){
    !this.props.block && this.setState({ open: false }, setStateCallback);
    return this;
  },

  toggle(setStateCallback){
    !this.props.block && this.setState((state) => ({ open: !state.open }), setStateCallback);
    return this;
  },

  isOpen() {
    return this.state.open;
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers

  _getMainProps: function () {
    let props = this.getMainPropsToPass();

    props.width = this.props.width;

    if (this.state.open) {
      props.className += ' ' + this.getClassName().open;
    }

    if (!this.props.block) {
      props.className += ' ' + this.getClassName().float;
      if (this.props.maxWidth && !this.state.open) {
        let ratio = 100 / (parseInt(this.props.maxWidth) / parseInt(this.props.minWidth));
        let transform = this.props.right ? 'translateX(' + (100 - ratio) + '%)' : 'translateX(' + (ratio - 100) + '%)';
        props.style = props.style || {};
        props.style.transform = transform;
      }
    }

    return props;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    let left = (
      <div >
        <Button content={<Glyphicon glyphicon='uu-glyphicon-cross' />} onClick={this.close}
                className={this.getClassName().buttonClose} />
        <Button content={<Glyphicon glyphicon='uu-glyphicon-menu' />} onClick={this.open}
                className={this.getClassName().buttonOpen} />
      </div>
    );
    let right = (
      <div >
        <Button content={<Glyphicon glyphicon='uu-glyphicon-menu' />} onClick={this.open}
                className={this.getClassName().buttonOpen} />
        <Button content={<Glyphicon glyphicon='uu-glyphicon-cross' />} onClick={this.close}
                className={this.getClassName().buttonClose} />
      </div>
    );

    let content;
    if (this.props.openContent && this.props.closedContent) {
      content = (this.props.block || this.state.open) ? this.props.openContent : this.props.closedContent;
      switch (typeof content) {
        case 'number':
          // content = content;
          break;
        case 'string':
          if (Tools.isUU5String(content)) {
            content = Tools.getChildrenFromUu5String(content);
          }
          break;
        default:
          content = React.cloneElement(content, { open: this.state.open, block: this.props.block });
      }
    }

    return (
      <Column {...this._getMainProps()}>
        {content}
        <div className={this.getClassName().buttonWrapper}>
          {this.props.button && (this.props.right ? right : left)}
        </div>
      </Column>
    );
  }
  //@@viewOff:render
});

export default PageColumn;



// WEBPACK FOOTER //
// ./bricks/page-column.js